import { EMPTY_LIST } from '../../../constants/common'

export function getChecklistProgress(checklistItems = EMPTY_LIST) {
  if (checklistItems.length === 0) {
    return 0
  }

  const checkedCount = checklistItems.filter(
    checklistItem => checklistItem.checked
  ).length

  return Math.round((checkedCount / checklistItems.length) * 100)
}
